import { useEffect, useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import DonationPanel from "@/components/site/DonationPanel";
import Manifesto from "@/components/site/Manifesto";
import Gallery from "@/components/site/Gallery";
import EditorialMarquee from "@/components/site/EditorialMarquee";
import Footer from "@/components/site/Footer";
import WhereMoneyGoes from "@/components/site/WhereMoneyGoes";
import Videos from "@/components/site/Videos";
import NoteFromMaria from "@/components/site/NoteFromMaria";
import Transparency from "@/components/site/Transparency";
import PastorVideo from "@/components/site/PastorVideo";
import MentalHealthUpdate from "@/components/site/MentalHealthUpdate";
import { FadeUp } from "@/components/site/Reveal";
import { getFundraiser, getGofundmeProgress } from "@/lib/api";
import { useI18n } from "@/context/Language";

export default function Fundraiser() {
  const { t, N } = useI18n();
  const S = t.scale;
  const [fundraiser, setFundraiser] = useState(null);

  useEffect(() => {
    (async () => {
      let base = null;
      try {
        base = await getFundraiser();
      } catch (_) { /* fallback to defaults */ }
      try {
        const gfm = await getGofundmeProgress();
        setFundraiser({ ...(base || {}), ...gfm });
      } catch (_) {
        if (base) setFundraiser(base);
      }
    })();
  }, []);

  const openDonate = () => {
    window.open(N.gofundmeUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <main className="relative">
      <Navbar onDonate={openDonate} />
      <Hero onDonate={openDonate} />
      <PastorVideo />
      <DonationPanel fundraiser={fundraiser} onDonate={openDonate} />

      <Manifesto />

      {/* Scale of the disaster (sober, factual) */}
      <section className="border-y border-border-soft bg-sand-2">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16 sm:py-20">
          <FadeUp>
            <span className="text-xs uppercase tracking-[0.24em] text-ink/40">{S.overline}</span>
          </FadeUp>
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-10">
            {S.items.map((stat, i) => (
              <FadeUp key={stat.label} delay={i * 0.1} className="border-t border-border-soft pt-5">
                <div className="font-serif text-5xl sm:text-6xl text-ink leading-none">{stat.value}</div>
                <div className="mt-3 text-sm text-ink/60">{stat.label}</div>
              </FadeUp>
            ))}
          </div>
          <FadeUp>
            <p className="mt-10 max-w-xl text-xs leading-relaxed text-ink/40">{S.footnote}</p>
          </FadeUp>
        </div>
      </section>

      <Gallery />
      <Videos />
      <MentalHealthUpdate />
      <EditorialMarquee />
      <WhereMoneyGoes />
      <Transparency />
      <NoteFromMaria />
      <Footer onDonate={openDonate} />
    </main>
  );
}
